import React from 'react';
import { useDispatch } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { SearchAreaFilterValue, SearchAreaValue } from 'ha/types/SearchFilters';
import { track } from 'ha/modules/Analytics/actions';

import CommonCheckboxFilter from './CommonCheckboxFilter';

export interface Props {
  value: SearchAreaFilterValue;
  onChange: (value: SearchAreaFilterValue) => void;
  checkboxSize?: 'small' | 'medium';
  location: 'filter' | 'map' | 'search results';
}

const SearchAreaFilter: React.FC<Props> = ({
  value,
  onChange,
  checkboxSize = 'medium',
  location,
}) => {
  const { T } = useIntl();
  const dispatch = useDispatch();

  const onSelect = React.useCallback(
    (selectedValue: SearchAreaFilterValue) => {
      const enabled = selectedValue.includes(SearchAreaValue.MapBounds);
      onChange(
        enabled ? [SearchAreaValue.MapBounds] : [SearchAreaValue.CityBounds],
      );

      dispatch(
        track('Map as filter clicked', {
          location,
          state: enabled ? 'enabled' : 'disabled',
        }),
      );
    },
    [dispatch, location, onChange],
  );

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onSelect}
      checkboxSize={checkboxSize}
      options={[
        {
          value: SearchAreaValue.MapBounds,
          title: T('search.map.map_as_filter.checkbox'),
          testLocator: 'Filter Use Map As Search Area',
        },
      ]}
    />
  );
};

export default SearchAreaFilter;
